import { api } from '../../lib/apiClient';

export type WalletListItem = {
  id: string;
  address: string;
  user_identity_id: string;
  email?: string;
  provider_user_id: string;
  auth_provider: string;
  chain_type: string;
  curve: string;
  networks?: string[];
  status: string;
  created_at: string;
  user_last_seen_at: string;
};

export type WalletsPage = {
  items: WalletListItem[];
  total: number;
  limit: number;
  offset: number;
};

export async function listWallets(
  orgId: string,
  params: { limit?: number; offset?: number } = {},
): Promise<WalletsPage> {
  const limit = params.limit ?? 200;
  const offset = params.offset ?? 0;
  const res = await api.get<{ data: WalletsPage }>(
    `/v1/orgs/${orgId}/wallets?limit=${limit}&offset=${offset}`,
  );
  return res.data.data;
}

export type WalletDetail = {
  id: string;
  address: string;
  user_identity_id: string;
  chain_type: string;
  curve: string;
  networks?: string[];
  status: 'active' | 'deprecated' | 'archived';
  created_at: string;
};

export async function getWallet(orgId: string, walletId: string): Promise<WalletDetail> {
  const res = await api.get<{ data: WalletDetail }>(`/v1/orgs/${orgId}/wallets/${walletId}`);
  return res.data.data;
}
